<mat-form-field appearance="outline" [class.shift-worktask-select-field]="!fullWidth" [class.dialog]="fullWidth" [class.full-width]="fullWidth">
	<mat-label *ngIf="label">{{ label }}</mat-label>
	<mat-select [ngModel]="value" (ngModelChange)="onSelectionChange($event)" [disabled]="disabled" (openedChange)="onOpenedChange($event)" panelClass="worktask-select-panel" [placeholder]="placeholder">
		<div class="worktask-filter-container">
			<input #workTaskFilterInput class="worktask-filter-input" [placeholder]="filterPlaceholder" [(ngModel)]="filter" [ngModelOptions]="{ standalone: true }" (ngModelChange)="filterWorkTasks()" (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
		</div>
		<mat-option *ngIf="includeNoneOption" [value]="null">{{ noneText }}</mat-option>
		@for (worktask of filteredWorkTasks; track trackByWorkTaskId($index, worktask)) {
			<mat-option [value]="getOptionValue(worktask)">({{ worktask.alias }}) {{ worktask.name }}</mat-option>
		}
	</mat-select>
</mat-form-field>
